/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { Icon, Grid, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Button } from "@mui/material";


// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";


import { getData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";
import { useSoftUIController } from "context";

// Images

// Images
import logoBet365 from "assets/images/providers/bet365.png";
import logoVbet from "assets/images/providers/vbet.png";
import logo1xbet from "assets/images/providers/onexbet.png";
import logoStoiximan from "assets/images/providers/stoiximan.png";
import logoMozzartBet from "assets/images/providers/mozzartbet.png";
import logoBetradar from "assets/images/providers/betradar.png";
import logoWilliamhill from "assets/images/providers/williamhill.png";
import logoBetanode from "assets/images/providers/betano-logo.png";
import logoDraftkings from "assets/images/providers/draftkings.png";
import logoBwin from "assets/images/providers/bwin.png";
import logoPaddypower from "assets/images/providers/paddypower.png";
import logoSbobet from "assets/images/providers/sbobet.png";
import logo188bet from "assets/images/providers/188bet.png";
import logoSportingbet from "assets/images/providers/sportingbet.png";
import logoUnibet from "assets/images/providers/unibet.png";
import logoFeedTheBet from "assets/images/providers/feedthebet.png";


let filterData = {};
let providersConstant = [];

let sportsCustomSorting = {
  soccer: 1,
  basketball: 2,
  tennis: 3,
  tabletennis: 4,
  volleyball: 5,
  handball: 6,
  badminton: 7,
  waterpolo: 8,
  beachvolleyball: 9,
  baseball: 10,
  futsal: 11,
};

function ProvidersFilters({ handleData, id, errorVisibility, errorLevel }) {
  const [controller, dispatch] = useSoftUIController();
  const { platform, permissions, sports, providers } = controller;
  const [checked, setChecked] = useState([]);
  const [selectedProviderSports, setSelectedProviderSports] = useState({
    provider: "",
    inplay: false,
    pregame: false,
    data: [],
  });
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedProvidersInplay, setSelectedProvidersInplay] = useState(false);
  const [selectedProvidersPregame, setSelectedProvidersPregame] = useState(false);
  const [providerSports, selectProviderSports] = useState("");
  const [sport, setSport] = useState("");
  const [sportType, setSportType] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [showError, setShowError] = useState(errorVisibility);

  async function initData() {
    //console.log("createPlatform initData");

    let apiData = await getApiData();

    let tmpSports = [...apiData.sports];
    if (id == 0) {
      let sportsperProvider = [];
      for (const key in apiData.providers) {
        if (Object.hasOwnProperty.call(apiData.providers, key)) {
          const provider = apiData.providers[key];
          for (const key in tmpSports) {
            if (Object.hasOwnProperty.call(tmpSports, key)) {
              const sport = tmpSports[key];
              let sportToPush = { ...sport };
              sportToPush.provider_id = provider.id;
              sportToPush.tm = new Date().getTime();
              sportsperProvider.push(sportToPush);
            }
          }
        }
      }
      tmpSports = sportsperProvider;
    }

    let providers = [];

    for (const key in apiData.providers) {
      if (Object.hasOwnProperty.call(apiData.providers, key)) {
        const provider = apiData.providers[key];
        let provider_sports = [...tmpSports.filter((sport) => sport.provider_id == provider.id)];
        let sorted_sports = provider_sports.sort((a, b) => {
          //return parseFloat(a.id) - parseFloat(b.id);
          if (a.sorting === b.sorting) {
            // same sorting then sort by name
            return b.name < a.name;
          }
          return a.sorting > b.sorting ? 1 : -1;
        });
        providers.push(
          createProviders(
            provider.id,
            provider.name,
            provider.selected ? provider.selected : false,
            provider.type,
            sorted_sports,
            provider.id === 1000 ? true : false
          )
        );
      }
    }

    providers = providers.sort((a, b) => {
      return parseFloat(a.id) - parseFloat(b.id);
    });

    providers = providers.sort((a, b) => {
      return a.master === b.master ? 0 : a.master ? -1 : 1;
    });

    for (const key in providers) {
      if (Object.hasOwnProperty.call(providers, key)) {
        const provider = providers[key];
        let provider_sports = [...tmpSports.filter((sport) => sport.provider_id == provider.id)];
        let sorted_sports = provider_sports.sort((a, b) => {
          //return parseFloat(a.id) - parseFloat(b.id);
          if (a.sorting === b.sorting) {
            // same sorting then sort by name
            return b.name < a.name;
          }
          return a.sorting > b.sorting ? 1 : -1;
        });
        filterData[provider.name] = sorted_sports;
      }
    }

    setSelectedProviderSports({ provider: "", inplay: false, pregame: false, data: [] });

    if (id > 0) {
      let tmpSelectedProviders = providers.filter((provider) => provider.selected == true);
      if (tmpSelectedProviders.length > 0) {
        setSelectedProviderSports({
          provider: tmpSelectedProviders[0].name,
          inplay:
            tmpSelectedProviders[0].sports[0].inplay || tmpSelectedProviders[0].sports[0].both,
          pregame:
            tmpSelectedProviders[0].sports[0].pregame || tmpSelectedProviders[0].sports[0].both,
          data: tmpSelectedProviders[0].sports,
        });

        setSelectedProvidersPregame(
          tmpSelectedProviders[0].sports[0].pregame || tmpSelectedProviders[0].sports[0].both
        );

        selectProviderSports(tmpSelectedProviders[0].name);

        setSelectedProviders(tmpSelectedProviders);
        handleData({ providers: tmpSelectedProviders });
        setSelectedProvidersInplay(
          tmpSelectedProviders[0].sports[0].inplay || tmpSelectedProviders[0].sports[0].both
        );
      }
    }

    providersConstant = providers;
  }

  function createSportsData(
    id: number,
    sorting: number,
    provider_id: number,
    name: string,
    inplay: boolean,
    pregame: boolean,
    both: boolean,
    selected: boolean,
    enabled: boolean,
    is_esport: boolean
  ) {
    return { id, sorting, provider_id, name, inplay, pregame, both, selected, enabled, is_esport };
  }

  function createProviders(
    id: number,
    name: string,
    selected: boolean,
    type: string,
    sports: array,
    master: boolean
  ) {
    return { id, name, selected, type, sports, master };
  }

  function createProvidersData(
    id: number,
    name: string,
    location: string,
    weight: string,
    logo,
    type: string,
    enabled: boolean,
    selected: boolean,
    master: boolean
  ) {
    return { id, name, location, weight, logo, type, enabled, selected, master };
  }

  async function getApiData() {
    let getFiltersEndpoint =
      id > 0 ? `/api/v1/platforms/${id}/master-template` : `/api/v1/templates/unis`; ///:id/master-template
    if (id === 0) setEditMode(false);
    if (id > 0) setEditMode(true);

    let response = await getData(getFiltersEndpoint, { Authorization: getAuthorizationHeader() });
    if (response != null) {
      let logoKeeper = {
        bet365: logoBet365,
        vbet: logoVbet,
        "1xbet": logo1xbet,
        stoiximan: logoStoiximan,
        mozzartbet: logoMozzartBet,
        betradar: logoBetradar,
        williamhill: logoWilliamhill,
        betanode: logoBetanode,
        draftkings: logoDraftkings,
        paddypower: logoPaddypower,
        bwin: logoBwin,
        sbobet: logoSbobet,
        sportingbet: logoSportingbet,
        "188bet": logo188bet,
        unibet: logoUnibet,
        feedthebet: logoFeedTheBet,
      };

      let myProviders = response.data.providers.map((el) => {
        el.location = el.location ? el.location : "-";
        el.weight = el.weight ? el.weight : "-";
        el.logo = logoKeeper[el.name];
        el.selected =
          id > 0 ? (el.inplay == true ? true : el.pregame == true ? true : false) : !el.status;
        el.enabled = true;
        el.master = el.id === 1000 ? true : false;
        el.type = "both";
        return createProvidersData(
          el.id,
          el.name,
          el.location,
          el.weight,
          el.logo,
          el.type,
          el.enabled,
          el.selected,
          el.master
        );
      });

      let mySports = response.data.sports.map((el) => {
        const sp = sports.find((s) => s.id == el.id);
        if (sp) {
          el.both = el.inplay ? (el.pregame ? true : false) : false;
          el.selected =
            id > 0 ? (el.inplay == true ? true : el.pregame == true ? true : false) : !el.status;
          el.enabled = id > 0 ? true : el.enabled;
          // if (el.both) {
          //   el.inplay = false;
          //   el.pregame = false;
          // }
          let sportSorting = sportsCustomSorting[el.name.replace(/ /g, "").toLowerCase()];
          el.sorting = sportSorting ? sportSorting : el.is_esport ? 3000 : 1000;

          if (!el.inplay || !el.pregame) {
            myProviders.find((mp) => mp.id == el.provider_id)["type"] = el.inplay
              ? "inplay"
              : el.pregame
              ? "pregame"
              : el.both
              ? "both"
              : "none";
          }

          return createSportsData(
            el.id,
            el.sorting,
            el.provider_id,
            el.name,
            el.inplay,
            el.pregame,
            el.both,
            el.selected,
            el.enabled,
            el.is_esport
          );
        } else return false;
      });
      mySports.filter((sp) => sp);
      mySports.sort((a, b) => {
        return a.sorting - b.sorting;
      });

      return { providers: myProviders, sports: mySports };
    } else {
      const iniSports = [
        createSportsData(1, "Soccer", false, false, true, false, true),
        createSportsData(2, "Basketball", false, false, true, false, true),
        createSportsData(3, "Tennis", false, false, true, false, true),
        createSportsData(4, "Table Tennis", false, false, true, false, true),
        createSportsData(5, "Ice Hockey", false, false, true, false, true),
        createSportsData(6, "Volleyball", false, false, true, false, true),
        createSportsData(7, "Handball", false, false, true, false, true),
        createSportsData(8, "Badminton", false, false, true, false, true),
        createSportsData(9, "Counter Strike", false, false, true, false, true),
        createSportsData(10, "Valorant", false, false, true, false, true),
        createSportsData(11, "American Football", false, false, true, false, false),
      ];

      const providers = [
        createProvidersData(1, "bet365", "Greece", "Auto", logoBet365, true),
        createProvidersData(2, "vbet", "Armenia", "Auto", logoVbet, false),
        createProvidersData(3, "1xbet", "Ukraine", "Auto", logo1xbet, true),
        createProvidersData(4, "stoiximan", "Greece", "Auto", logoStoiximan, true),
        createProvidersData(5, "mozzarbet", "Greece", "Auto", logoMozzartBet, true),
        createProvidersData(6, "betradar", "Greece", "Auto", logoBetradar, true),
        createProvidersData(7, "williamhill", "Greece", "Auto", logoWilliamhill, true),
        createProvidersData(8, "betanode", "Greece", "Auto", logoBetanode, true),
        createProvidersData(9, "draftkings", "Greece", "Auto", logoDraftkings, true),
        createProvidersData(10, "paddypower", "Greece", "Auto", logoPaddypower, true),
        createProvidersData(11, "bwin", "Greece", "Auto", logoBwin, true),
      ];

      return { providers: providers, sports: iniSports };
    }
  }

  const handleProviderChange = (event) => {
    event.preventDefault();
    setChecked([event.target.checked, checked[event.target.name]]);
    let selectedprovider = providersConstant.find((provider) => provider.id == event.target.name);

    const tmpSelectedProviders = [...selectedProviders];

    if (selectedprovider) {
      selectedprovider.selected = !selectedprovider.selected;
      if (selectedprovider.selected) {
        tmpSelectedProviders.push(selectedprovider);
      } else {
        const previousRowsIndex = tmpSelectedProviders.findIndex(
          (rowSport) => rowSport.id === selectedprovider.id
        );
        if (selectedprovider.id == providerSports) selectProviderSports("");
        tmpSelectedProviders.splice(previousRowsIndex, 1);
      }
      handleData({ providers: tmpSelectedProviders });
    }

    setSelectedProviders([]);
    setSelectedProviders(tmpSelectedProviders);
    if (tmpSelectedProviders.length == 0) {
      setSelectedProviderSports({ provider: "", inplay: false, pregame: false, data: [] });
    }
  };

  const handleProviderChangeConfig = (e) => {
    e.preventDefault();
    //console.log("providerClicked: ", e.currentTarget.value);
    const providerId = parseInt(e.currentTarget.value);
    //console.log("providerClicked: ", e.currentTarget.value);
    let selectedprovider = providersConstant.find((provider) => provider.id == providerId);
    selectProviderSports(selectedprovider.name);
    if (providerId) {
      selectedprovider.sports = filterData[selectedprovider.name];
      let providerSports = selectedprovider.sports.sort((a, b) => {
        //return parseFloat(a.id) - parseFloat(b.id);
        if (a.sorting === b.sorting) {
          // same sorting then sort by name
          return b.name < a.name;
        }
        return a.sorting > b.sorting ? 1 : -1;
      });
      let selectedSportIndex = selectedprovider.sports.findIndex((ps) => ps.selected);
      //console.log("providerSports: ", providerSports);
      setSelectedProviderSports({
        provider: selectedprovider.name,
        inplay:
          selectedSportIndex > -1
            ? selectedprovider.sports[selectedSportIndex].inplay ||
              selectedprovider.sports[selectedSportIndex].both
            : false,
        pregame:
          selectedSportIndex > -1
            ? selectedprovider.sports[selectedSportIndex].pregame ||
              selectedprovider.sports[selectedSportIndex].both
            : false,
        data: selectedprovider.sports,
      });
      setSelectedProvidersInplay(
        selectedSportIndex > -1
          ? selectedprovider.sports[selectedSportIndex].inplay ||
              selectedprovider.sports[selectedSportIndex].both
          : false
      );
      setSelectedProvidersPregame(
        selectedSportIndex > -1
          ? selectedprovider.sports[selectedSportIndex].pregame ||
              selectedprovider.sports[selectedSportIndex].both
          : false
      );
    }
  };

  const handleSportChange = (e, sport) => {
    e.preventDefault();
    setSelectedProviders([]);
    const tmpSelectedProviders = [...selectedProviders];
    sport.selected = !sport.selected;
    sport.inplay = selectedProvidersInplay;
    sport.pregame = selectedProvidersPregame;
    //console.log(JSON.stringify(sport));
    setSelectedProviders(tmpSelectedProviders.filter((provider) => provider.selected == true));
    handleData({ providers: tmpSelectedProviders });
  };

  const handleAllSelection = (e, status, group) => {
    e.preventDefault();
    const tmpSelectedProviders = [...selectedProviders];
    let selectedProviderId = selectedProviders.findIndex(
      (provider) => provider.name == providerSports
    );
    const esport = group === "sports" ? false : true;

    selectedProviders[selectedProviderId].sports.forEach((sport) => {
      if (sport.is_esport && esport) {
        sport.selected = status;
        sport.inplay = status ? selectedProvidersInplay : false;
        sport.pregame = status ? selectedProvidersPregame : false;
      }
      if (!sport.is_esport && !esport) {
        sport.selected = status;
        sport.inplay = status ? selectedProvidersInplay : false;
        sport.pregame = status ? selectedProvidersPregame : false;
      }
    });
    setSelectedProviders([]);
    setSelectedProviders(tmpSelectedProviders.filter((provider) => provider.selected == true));
    handleData({ providers: tmpSelectedProviders });
  };

  const setSportsTypeSelection = (e, type) => {
    e.preventDefault();

    const selectedSports = selectedProviderSports.data.filter((s) => s.selected);
    if (selectedSports.length > 0) {
      let prevStatus = selectedSports[0][type];
      selectedProviderSports.data
        .filter((s) => s.selected)
        .map((s) => {
          s[type] = !prevStatus;
          if (s.inplay && s.pregame) s.both = true;
          s.both = false;
        });
      selectedProviderSports[type] = !prevStatus;
      if (type == "inplay" || type == "both") setSelectedProvidersInplay(!prevStatus);
      if (type == "pregame" || type == "both") setSelectedProvidersPregame(!prevStatus);
      const tmpSelectedProviders = [...selectedProviders];
      let selectedProviderId = selectedProviders.findIndex(
        (provider) => provider.name == providerSports
      );
      selectedProviders[selectedProviderId].sports.forEach((sport) => {
        if (sport.selected) {
          sport[type] = !prevStatus;
        }
      });
      setSelectedProviders([]);
      setSelectedProviders(tmpSelectedProviders.filter((provider) => provider.selected == true));
      handleData({ providers: tmpSelectedProviders });
    }
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    setShowError(errorVisibility);
  }, [errorVisibility]);

  // useEffect(() => {
  //   console.log("selectedProviderSports CHANGED");
  //   console.log("selectedProviderSports-value: ", selectedProviderSports);
  // }, [selectedProviderSports]);

  return (
    <SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={2} container justifyContent="center">
            <SoftBox position="relative" height="max-content" mx="auto">
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">Available Providers *</FormLabel>
                <hr />
                <FormGroup className="platform-providers-holder">
                  {providersConstant.map((provider) => (
                    <FormGroup
                      row
                      key={`${provider.id}-holder`}
                      className="platform-providers-item-holder"
                    >
                      <FormControlLabel
                        className="providers-checkbox"
                        control={
                          <Checkbox
                            checked={provider.selected}
                            onClick={handleProviderChange}
                            name={String(provider.id)}
                          />
                        }
                        key={`${provider.id}-checkbox`}
                      />
                      <SoftTypography
                        key={`${provider.id}-label`}
                        className={
                          provider.master
                            ? "provider-checkbox-label-master"
                            : "provider-checkbox-label"
                        }
                      >
                        {provider.name}{" "}
                        <Icon sx={{ display: provider.master ? "" : "none", marginRight: "5px" }}>
                          workspace_premium_icon
                        </Icon>
                        <sup
                          style={{
                            color: "#17c1e8",
                            display:
                              provider.sports.filter((item) => item.selected == true).length > 0
                                ? ""
                                : "none",
                          }}
                        >
                          {provider.sports.filter((item) => item.selected == true).length}
                        </sup>
                      </SoftTypography>
                    </FormGroup>
                  ))}
                </FormGroup>
              </FormControl>
            </SoftBox>
          </Grid>
          <Grid item xs={12} sm={10}>
            <SoftBox className="grey-holder">
              <div
                className="error"
                style={{
                  display: showError ? "block" : "none",
                  textAlign: "right",
                  fontSize: "0.75rem",
                }}
              >
                {errorLevel == 2
                  ? "Misconfigure: Please select the Type of Events (inplay/pregame) per Provider to Continue!"
                  : "Misconfigure: Please select at least one Sport per Provider to Continue!"}
              </div>
              <SoftBox mt={2} display="flex" style={{ position: "relative", flexWrap: "wrap" }}>
                {selectedProviders.map((provider) => (
                  // let sportmissing = provider.sports.filter(sp=>sp.selected)
                  <SoftBox key={`holder-${provider.id}`} className={"platform-provider-button"}>
                    <SoftButton
                      key={provider.id}
                      variant="contained"
                      color={providerSports === provider.name ? "info" : "light"}
                      size="small"
                      sx={{
                        marginLeft: "5px",
                        marginBottom: "5px",
                        minWidth: "100px",
                        padding: "0px !important",
                      }}
                      value={provider.id}
                      onClick={handleProviderChangeConfig}
                    >
                      {provider.name}
                    </SoftButton>
                    <Icon
                      style={{
                        color: "#cb0c9f",
                        position: "absolute",
                        zIndex: 10,
                        right: "5px",
                        top: "2px",
                        display:
                          errorLevel == 0
                            ? "none"
                            : provider.sports.filter(
                                (item) => item.selected == true && (item.inplay || item.pregame)
                              ).length > 0
                            ? "none"
                            : "",
                      }}
                    >
                      info_outline_icon
                    </Icon>
                  </SoftBox>
                ))}
              </SoftBox>
              <SoftBox
                sm={12}
                mt={2}
                className="select-all-holder"
                // style={{
                //   display: selectedProviderSports.data
                //     ? selectedProviderSports.data.filter(
                //         (item) => item.selected == true && !item.is_esport
                //       ).length > 0
                //       ? "flex"
                //       : "none"
                //     : "none",
                // }}
              >
                <Button
                  style={{
                    color: selectedProvidersInplay
                      ? "#17c1e8"
                      : selectedProviderSports.data
                      ? selectedProviderSports.data.filter(
                          (item) => item.selected == true && !item.is_esport
                        ).length > 0
                        ? "rgb(119, 119, 119)"
                        : "#ff6969"
                      : "#ff6969",
                  }}
                  disabled={
                    selectedProviderSports.data
                      ? selectedProviderSports.data.filter(
                          (item) => item.selected == true && !item.is_esport
                        ).length > 0
                        ? false
                        : true
                      : true
                  }
                  onClick={(e) => setSportsTypeSelection(e, "inplay")}
                >
                  inplay
                </Button>
                <Button
                  style={{
                    color: selectedProvidersPregame
                      ? "#17c1e8"
                      : selectedProviderSports.data
                      ? selectedProviderSports.data.filter(
                          (item) => item.selected == true && !item.is_esport
                        ).length > 0
                        ? "rgb(119, 119, 119)"
                        : "#ff6969"
                      : "#ff6969",
                  }}
                  disabled={
                    selectedProviderSports.data
                      ? selectedProviderSports.data.filter(
                          (item) => item.selected == true && !item.is_esport
                        ).length > 0
                        ? false
                        : true
                      : true
                  }
                  onClick={(e) => setSportsTypeSelection(e, "pregame")}
                >
                  pregame
                </Button>
              </SoftBox>
              <SoftBox
                sm={12}
                mt={2}
                className="select-all-holder"
                style={{ display: selectedProviderSports.data.length > 0 ? "flex" : "none" }}
              >
                <Grid item xs={12} sm={3} sx={{ textAlign: "left" }}>
                  <SoftTypography variant="label">
                    Sports Selected:{" "}
                    <span style={{ color: "#17c1e8" }}>
                      {selectedProviderSports.data
                        ? selectedProviderSports.data.filter(
                            (item) => item.selected == true && !item.is_esport
                          ).length
                        : 0}
                    </span>
                  </SoftTypography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <SoftButton
                    variant="outlined"
                    color="info"
                    size="small"
                    sx={{
                      marginLeft: "5px",
                      marginBottom: "5px",
                      minWidth: "100px",
                      padding: "0px !important",
                    }}
                    onClick={(e) => handleAllSelection(e, true, "sports")}
                  >
                    Select all
                  </SoftButton>
                  <SoftButton
                    variant="outlined"
                    color="info"
                    size="small"
                    sx={{
                      marginLeft: "5px",
                      marginBottom: "5px",
                      minWidth: "100px",
                      padding: "0px !important",
                    }}
                    onClick={(e) => handleAllSelection(e, false, "sports")}
                  >
                    Diselect all
                  </SoftButton>
                </Grid>
              </SoftBox>
              <FormGroup row>
                {selectedProviderSports.data
                  .filter((s) => !s.is_esport)
                  .map((sport) => (
                    <FormGroup row key={`${sport.id}-holder`}>
                      <FormControlLabel
                        className="platform-sports-checkbox"
                        control={
                          <Checkbox
                            checked={sport.selected}
                            onClick={(e) => {
                              handleSportChange(e, sport);
                            }}
                            name={String(sport.id)}
                          />
                        }
                        key={`${sport.id}-checkbox`}
                      />
                      <SoftTypography
                        key={`${sport.id}-label`}
                        className="platform-sports-checkbox-label"
                      >
                        {sport.name}
                      </SoftTypography>
                    </FormGroup>
                  ))}
              </FormGroup>
              <SoftBox
                sm={12}
                mt={2}
                className="select-all-holder"
                style={{ display: selectedProviderSports.data.length > 0 ? "flex" : "none" }}
              >
                <Grid item xs={12} sm={3} sx={{ textAlign: "left" }}>
                  <SoftTypography variant="label">
                    eSports Selected:{" "}
                    <span style={{ color: "#17c1e8" }}>
                      {selectedProviderSports.data
                        ? selectedProviderSports.data.filter(
                            (item) => item.selected == true && item.is_esport
                          ).length
                        : 0}
                    </span>
                  </SoftTypography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <SoftButton
                    variant="outlined"
                    color="info"
                    size="small"
                    sx={{
                      marginLeft: "5px",
                      marginBottom: "5px",
                      minWidth: "100px",
                      padding: "0px !important",
                    }}
                    onClick={(e) => handleAllSelection(e, true, "esports")}
                  >
                    Select all
                  </SoftButton>
                  <SoftButton
                    variant="outlined"
                    color="info"
                    size="small"
                    sx={{
                      marginLeft: "5px",
                      marginBottom: "5px",
                      minWidth: "100px",
                      padding: "0px !important",
                    }}
                    onClick={(e) => handleAllSelection(e, false, "esports")}
                  >
                    Diselect all
                  </SoftButton>
                </Grid>
              </SoftBox>
              <FormGroup row>
                {selectedProviderSports.data
                  .filter((s) => s.is_esport)
                  .map((sport) => (
                    <FormGroup row key={`${sport.id}-holder`}>
                      <FormControlLabel
                        className="platform-sports-checkbox"
                        control={
                          <Checkbox
                            checked={sport.selected}
                            onClick={(e) => {
                              handleSportChange(e, sport);
                            }}
                            name={String(sport.id)}
                          />
                        }
                        key={`${sport.id}-checkbox`}
                      />
                      <SoftTypography
                        key={`${sport.id}-label`}
                        className="platform-sports-checkbox-label"
                      >
                        {sport.name}
                      </SoftTypography>
                    </FormGroup>
                  ))}
              </FormGroup>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

// typechecking props for ProvidersFilters
ProvidersFilters.propTypes = {
  handleData: PropTypes.func,
  id: PropTypes.number,
  errorVisibility: PropTypes.bool,
  errorLevel: PropTypes.number,
};

export default ProvidersFilters;
